'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.queryWatcherFactory = undefined;

var _reduxSaga = require('redux-saga');

var _queryObserver = require('./queryObserver');

var _queryObserver2 = _interopRequireDefault(_queryObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryWatcherFactory = exports.queryWatcherFactory = function queryWatcherFactory(queryObserverImpl) {
    return function (watcher, emitter) {
        var observer = queryObserverImpl(emitter);
        watcher.subscribe(observer);

        var unsubscribe = function unsubscribe() {
            observer.unsubscribe();
        };

        return unsubscribe;
    };
};

exports.default = function (watcher) {
    return (0, _reduxSaga.eventChannel)(function (emitter) {
        return queryWatcherFactory(_queryObserver2.default)(watcher, emitter);
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/realtime/createApolloQueryChannel.js
// module id = 941
// module chunks = 0